export default __webpack_public_path__ + "static/media/Designer _Flatline.5149f113.svg";